import { z } from 'zod';
import { modelTaskSchema } from '../enums.js';
/**
 * Objectif d'un projet (ADR-0028) : l'**intention** — quoi construire et comment — attachée à un
 * `Projet` transverse (relation 1-1). C'est le seul état *stocké* de la fonctionnalité ; l'avancement,
 * lui, reste **dérivé** (cf. `deriveObjectivePlan`). Les valeurs sont des **codes en anglais** ; les
 * libellés affichés viennent de l'i18n du front.
 */
/** Modalité de la donnée d'entrée. */
export const OBJECTIVE_DATA_MODALITIES = [
    'OPTICAL',
    'INFRARED',
    'ACOUSTIC',
    'RADAR',
    'TELEMETRY',
];
export const dataModalitySchema = z.enum(OBJECTIVE_DATA_MODALITIES);
/** Support / granularité de la donnée. */
export const OBJECTIVE_SUPPORTS = ['IMAGE', 'VIDEO_STREAM', 'TIME_SERIES'];
export const objectiveSupportSchema = z.enum(OBJECTIVE_SUPPORTS);
/** Cible de déploiement (rejoindra la flotte de matériels, chantier ultérieur). */
export const OBJECTIVE_DEPLOY_TARGETS = ['DRONE', 'UGV', 'GROUND'];
export const deployTargetSchema = z.enum(OBJECTIVE_DEPLOY_TARGETS);
/** Ce que l'organisation possède déjà comme données. */
export const OBJECTIVE_DATA_ON_HAND = ['NONE', 'VIDEOS', 'LOGS'];
export const dataOnHandSchema = z.enum(OBJECTIVE_DATA_ON_HAND);
/** Corps de création/mise à jour d'un objectif (le `projectId` voyage dans l'URL). Idempotent. */
export const upsertObjectiveSchema = z.object({
    task: modelTaskSchema,
    // Cibles / classes visées : noms libres (référentiel de labels ou saisie), au plus 50.
    targets: z.array(z.string().trim().min(1).max(80)).max(50).default([]),
    dataModality: dataModalitySchema,
    support: objectiveSupportSchema,
    deployTarget: deployTargetSchema,
    dataOnHand: dataOnHandSchema,
});
/** Objectif tel que restitué par l'API. */
export const objectiveSchema = upsertObjectiveSchema.extend({
    id: z.string(),
    projectId: z.string(),
    organizationId: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
/**
 * Signaux de décompte du périmètre projet, servant à **dériver** le plan (jamais stockés) :
 * annotations validées des vidéos du projet, modèles associés prêts, modèles évalués.
 */
export const objectiveSignalsSchema = z.object({
    annotatedCount: z.number().int().nonnegative(),
    readyModelCount: z.number().int().nonnegative(),
    evaluatedModelCount: z.number().int().nonnegative(),
});
/**
 * Vue liste (page Model) : chaque projet de l'organisation, son objectif (ou `null`) et ses signaux.
 * Le plan se dérive côté front via `deriveObjectivePlan` — jamais transporté ni stocké.
 */
export const objectiveListItemSchema = z.object({
    projectId: z.string(),
    projectName: z.string(),
    objective: objectiveSchema.nullable(),
    signals: objectiveSignalsSchema,
});
//# sourceMappingURL=objective.js.map